// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__3kFVx","content":"GlobalSearch_content__1nlrq"};